import { HttpParams } from '@angular/common/http';

export function addAdditionalParams(
  httpParams: HttpParams,
  additionalParams: Record<string, unknown>,
): HttpParams {
  if (!httpParams) return httpParams;
  if (!additionalParams) return httpParams;
  let updatedParams = httpParams;

  Object.entries(additionalParams).forEach(([key, value]) => {
    if (value) updatedParams = updatedParams.append(key, value.toString());
  });
  return updatedParams;
}
